import { useState } from 'react';

import { U21Button } from 'app/shared/u21-ui/components';
import { IconBookmarkPlus } from '@u21/tabler-icons';

import { Filter, FilterContext, SavedFilter } from 'app/modules/filters/models';
import { CreateSavedFilterModal } from 'app/modules/filters/components/CreateSavedFilterModal';
import { areFiltersEqual } from 'app/modules/filters/utils';

interface Props {
  appliedSavedFilter: SavedFilter | undefined;
  defaultFilters: Filter[];
  duplicateSavedFilter?: SavedFilter;
  filterContext: FilterContext;
  filters: Filter[];
  onAppliedSavedFilterChange: (savedFilter: SavedFilter | undefined) => void;
}

export const SaveFilterButton = ({
  appliedSavedFilter,
  defaultFilters,
  duplicateSavedFilter,
  filterContext,
  filters,
  onAppliedSavedFilterChange,
}: Props) => {
  const [createModalOpen, setCreateModalOpen] = useState(false);

  if (filters.length === 0 || areFiltersEqual(filters, defaultFilters)) {
    return null;
  }

  const saveAsNewDisabled = duplicateSavedFilter !== undefined;
  const saveAsNewTooltip = duplicateSavedFilter
    ? `A saved filter with these filters already exists: "${duplicateSavedFilter.title}".`
    : undefined;

  return (
    <>
      <U21Button
        color="primary"
        disabled={saveAsNewDisabled}
        disableTitleCase
        onClick={() => setCreateModalOpen(true)}
        size="small"
        startIcon={<IconBookmarkPlus />}
        tooltip={saveAsNewTooltip}
        variant="outlined"
      >
        {appliedSavedFilter && !saveAsNewDisabled
          ? 'Save as New Filter'
          : 'Save Filter'}
      </U21Button>
      <CreateSavedFilterModal
        filterContext={filterContext}
        filters={filters}
        onClose={() => setCreateModalOpen(false)}
        onSaved={onAppliedSavedFilterChange}
        open={createModalOpen}
      />
    </>
  );
};
